import { useMemo } from 'react';
import * as tradeInsSelectors from '@makemydeal/dr-dash-store/selectors/tradeIns';
import * as tradeInsActionCreators from '@makemydeal/dr-dash-store/actions/tradeInsActionCreators';

export const useTradeItemSelectors = (originalIndex: number, isAllowanceSourceIndicatorEnabled: boolean = false) => {
    return useMemo(() => {
        return {
            allowanceSelector: tradeInsSelectors.getTradeValue(originalIndex),
            payoffSelector: tradeInsSelectors.getTradeInAmountOwed(originalIndex),
            acvSelector: tradeInsSelectors.getTradeACV(originalIndex),
            allowanceAction: tradeInsActionCreators.allowanceChanged(originalIndex, isAllowanceSourceIndicatorEnabled),
            payoffAction: tradeInsActionCreators.payoffChanged(originalIndex),
            acvAction: tradeInsActionCreators.acvChanged(originalIndex)
        };
    }, [originalIndex, isAllowanceSourceIndicatorEnabled]);
};
